import axios from "axios";

// export let USER_API_URL = "http://localhost/yitaconnect";
export let USER_API_URL = "/api";
// export let USER_API_URL = "https://yitalife.com/api";
class Api {
  getAppointments(e) {
    return axios.get(`${USER_API_URL}/read1.php`);
  }
  getImage(e) {
    return axios.get(`${USER_API_URL}/images.php`);
  }
  createAppointments(user) {
    return axios.post(`${USER_API_URL}/write.php`, user);
  }
  sendmail(user) {
    return axios.post(`${USER_API_URL}/mail.php`, user);
  }
  sendAppointmentNotification(appointment) {
    const fieldLabels = {
      name: "Patient Name",
      age: "Age",
      gender: "Sex / Gender",
      phone: "Phone Number",
      email: "Email",
      address: "Address / Area",
      occupation: "Occupation",
      level: "Education Level",
      package: "Service Requested",
      concern: "Main Concern",
      otherconcern: "Additional Notes",
      weight: "Weight",
      height: "Height",
      smoke: "Smokes",
      alcohol: "Takes Alcohol",
      udrug: "Current Medicines",
      unknowndrug: "Drug / Medicine Allergies",
      anypastsurvery: "Past Surgery / Transfusion / Accident",
      unknownchronic: "Chronic / Family Conditions",
      visidate: "Preferred Visit Date",
      visittime: "Preferred Visit Time",
      feedback: "Additional Note",
      paymentmode: "Payment Mode",
      ref: "Reference",
      Tx: "Transaction ID",
    };

    const data = Object.entries(appointment)
      .filter(([key, value]) => value && !["action", "PaidId", "PaidAmount", "mass", "tribe", "religion", "anymedi", "unknownfamily", "cost", "qty"].includes(key))
      .map(([key, value]) => `${fieldLabels[key] || key}: ${value}`)
      .join("\n");

    return this.sendInternalMail({
      to: "info@yitalife.com",
      recipient: "info@yitalife.com",
      replyTo: appointment.email,
      name: appointment.name,
      from: "info@yitalife.com",
      Tx: appointment.Tx,
      subject: `New appointment request — ${appointment.package} — ${appointment.name}`,
      msg: "A new appointment request has been submitted through the Yita Life website.",
      data,
      formType: "appointment",
      appointment,
    });
  }
  sendNewsletterSubscription(subscription) {
    return this.sendInternalMail({
      to: "communication@yitalife.com",
      recipient: "communication@yitalife.com",
      replyTo: subscription.email,
      name: subscription.name,
      from: "communication@yitalife.com",
      subject: `New newsletter subscription: ${subscription.name}`,
      msg: "A visitor has subscribed to the Yita Life health newsletter.",
      data: `Name: ${subscription.name}\nEmail: ${subscription.email}\nPhone: ${subscription.phone || "Not provided"}`,
      formType: "newsletter-subscription",
      subscription,
    });
  }
  sendContactMessage(message) {
    const fullName = [message.firstName, message.lastName]
      .filter(Boolean)
      .join(" ");
    return this.sendInternalMail({
      to: "mobiledoctor@yitalife.com",
      recipient: "mobiledoctor@yitalife.com",
      replyTo: message.email,
      name: fullName,
      from: "mobiledoctor@yitalife.com",
      subject: `Website contact message: ${message.subject || "General inquiry"}`,
      msg: "A visitor has sent a message through the Yita Life contact page.",
      data: `Name: ${fullName}\nEmail: ${message.email}\nPhone: ${message.phone || "Not provided"}\nTopic: ${message.subject || "General inquiry"}\n\nMessage:\n${message.message}`,
      formType: "contact-message",
      contactMessage: message,
    });
  }
  async sendInternalMail(message) {
    const response = await this.sendmail(message);
    if (
      typeof response.data === "string" &&
      response.data.trim().toLowerCase() !== "success"
    ) {
      throw new Error(response.data);
    }
    return response;
  }
  sendmailp(user) {
    return axios.post(`${USER_API_URL}/mailp.php`, user);
  }
  getUserById(Username, Password) {
    console.log("DFGHJKL:", Username);
    return axios.get(`${USER_API_URL}/single_user.php`, {
      params: { Username: Username, Password: Password },
    });
  }
  getAppointOne(e) {
    return axios.get(`${USER_API_URL}/oneappoint.php`, {
      params: { Tx: e },
    });
  }
  LoginUser(e, b) {
    return axios.get(`${USER_API_URL}/user.php`, {
      params: { Username: e, Password: b }, //this one gets the username and password
    });
  }
  GetSingle(e) {
    return axios.get(`${USER_API_URL}/single.php`, {
      params: { Email: e },
    }); // here you just get the email of the user
  }

  deleteRecord(Invoice) {
    return axios.delete(`${USER_API_URL}/delete.php`, {
      params: { Invoice: Invoice }, // you can delete the invoice at this point
    });
  }
  DelImg(Id) {
    return axios.delete(`${USER_API_URL}/detateimage.php`, {
      params: { Id: Id }, // you can as well delete the image at this point
    });
  }
  updateBank(data) {
    return axios.put(`${USER_API_URL}/UpdateBank.php`, data);
  }
  updatePay(data) {
    return axios.put(`${USER_API_URL}/updateone.php`, data);
  }
  UpPass(data) {
    return axios.put(`${USER_API_URL}/updatePass.php`, data);
  }
  updateAction(data) {
    return axios.put(`${USER_API_URL}/manage.php`, data);
  }
  updateInvoiceAll(data) {
    return axios.put(`${USER_API_URL}/updateAllInvoice.php`, data);
  }
  upload(data) {
    return axios.post(`${USER_API_URL}/up.php`, data, {});
  }
  saveUpload(data) {
    return axios.post(`${USER_API_URL}/savelink.php`, data, {});
  }
}
export default new Api();
